import "./styles.less";

import React, { MouseEvent } from "react";
import { Button } from "shared-components/Components/Buttons/web";
import { MessageIcon } from "shared-components/Components/CustomIcons/MessageIcon/web";
import { FormCallToActions } from "shared-components/Contexts/ContactModal/context";

//validar todos los lugares donde se llame este componente
export const FormButton = ({
	idealFilters,
	isDark,
	callback,
	disabled = false
}: {
	idealFilters?: any;
	isDark?: boolean;
	callback: ({ ctaButtons } : { ctaButtons: FormCallToActions }) => void;
	disabled?: boolean;
}) => {
	const clickHandler = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		callback({ctaButtons: {
			contact: true,
			phone: false,
			whatsapp: false
		}});

		if (idealFilters) localStorage.setItem("propertyIdealFilters", JSON.stringify(idealFilters));
	};

	return (
		<>
			<Button
				onClick={e => clickHandler(e)} style={{ width: "100%" }}
				className={`btn-primary ${isDark ? 'btn-dark' : ''}`}
				disabled={disabled}
			>
				<MessageIcon /> Contactar
			</Button>
		</>
	);
};


